import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

// Предполагаем, что у нас есть библиотека @jsonforms/react для рендеринга форм,
// но в прототипе конструктора мы не рендерим форму, а только строим schema.
// Для демонстрации можно добавить предпросмотр с JSONForms.

import { JsonForms } from '@jsonforms/react';
import { materialRenderers, materialCells } from '@jsonforms/material-renderers';

// Основной компонент конструктора форм
const FormBuilderGrok = () => {
  const [schema, setSchema] = useState({
    type: 'object',
    properties: {},
    required: [],
  });

  const [uiSchema, setUiSchema] = useState({});

  const [fields, setFields] = useState([]);

  // Функция добавления нового поля
  const addField = (type) => {
    const newField = {
      id: uuidv4(),
      name: `field_${fields.length + 1}`,
      type,
      title: `New ${type} Field`,
    };

    setFields([...fields, newField]);
    updateSchema([...fields, newField]);
  };

  // Функция обновления поля
  const updateField = (id, updates) => {
    const updatedFields = fields.map((field) =>
      field.id === id ? { ...field, ...updates } : field
    );
    setFields(updatedFields);
    updateSchema(updatedFields);
  };

  // Функция удаления поля
  const removeField = (id) => {
    const updatedFields = fields.filter((field) => field.id !== id);
    setFields(updatedFields);
    updateSchema(updatedFields);
  };

  // Функция обновления JSON Schema на основе списка полей
  const updateSchema = (updatedFields) => {
    const newProperties = {};
    const newRequired = [];

    updatedFields.forEach((field) => {
      const fieldSchema = {
        type: field.type,
        title: field.title,
        description: field.description,
      };

      if (field.enum) {
        fieldSchema.enum = field.enum;
      }

      if (field.type === 'array' && field.items) {
        fieldSchema.items = field.items;
      }

      if (field.type === 'object' && field.properties) {
        fieldSchema.properties = field.properties;
      }

      newProperties[field.name] = fieldSchema;
      // Для примера, делаем все поля required; можно добавить флаг
      newRequired.push(field.name);
    });

    setSchema({
      type: 'object',
      properties: newProperties,
      required: newRequired,
    });

    // UISchema можно генерировать автоматически или редактировать отдельно
    setUiSchema({
      type: 'VerticalLayout',
      elements: updatedFields.map((field) => ({
        type: 'Control',
        scope: `#/properties/${field.name}`,
      })),
    });
  };

  // Экспорт schema в JSON
  const exportSchema = () => {
    const fullSchema = { schema, uiSchema };
    console.log(JSON.stringify(fullSchema, null, 2));
    // Здесь можно добавить сохранение в файл или API
  };

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      {/* Левая панель: Конструктор */}
      <div style={{ width: '50%', padding: '20px', borderRight: '1px solid #ccc' }}>
        <h2>Form Builder</h2>
        <div>
          <button onClick={() => addField('string')}>Add String Field</button>
          <button onClick={() => addField('number')}>Add Number Field</button>
          <button onClick={() => addField('boolean')}>Add Boolean Field</button>
          {/* Добавьте больше типов по необходимости */}
        </div>
        <ul>
          {fields.map((field) => (
            <li key={field.id}>
              <input
                value={field.name}
                onChange={(e) => updateField(field.id, { name: e.target.value })}
                placeholder="Field Name"
              />
              <input
                value={field.title}
                onChange={(e) => updateField(field.id, { title: e.target.value })}
                placeholder="Field Title"
              />
              <input
                value={field.description || ''}
                onChange={(e) => updateField(field.id, { description: e.target.value })}
                placeholder="Description"
              />
              <button onClick={() => removeField(field.id)}>Remove</button>
            </li>
          ))}
        </ul>
        <button onClick={exportSchema}>Export Schema</button>
      </div>

      {/* Правая панель: Предпросмотр формы с JSONForms */}
      <div style={{ width: '50%', padding: '20px' }}>
        <h2>Form Preview</h2>
        <JsonForms
          schema={schema}
          uischema={uiSchema}
          data={{}} // Пустые данные для предпросмотра
          renderers={materialRenderers}
          cells={materialCells}
          onChange={({ data }) => console.log('Form data:', data)} // Для демонстрации
        />
      </div>
    </div>
  );
};

export default FormBuilderGrok;